/**
 * =============================================================================
 * nav.js
 * =============================================================================

 * =============================================================================
 */

var Nav = {
  headerSectionElement: null,
  data: {
    selectors: {
      navOffcanvas: ".offcanvas",
      navOffcanvasContent: ".nav-offcanvas-content"      
    }
  },
  
  init: function() {
    this.headerSectionElement = document.querySelector('.section-header');
    this.setupScrollListener();
    document.addEventListener('interaction:down-scroll', this.onScrollDown.bind(this));
    document.addEventListener('interaction:up-scroll', this.onScrollUp.bind(this));
  },

  /**
   * Automatically called by mp.js when document is ready. Perform any jQuery
   * setup for the extension here (e.g. event listeners, initial state)
   */
  onReady: function(){
    document.querySelectorAll(this.data.selectors.navOffcanvasContent).forEach(e => {
      e.style.width = document.querySelector(this.data.selectors.navOffcanvas).getBoundingClientRect().width + "px"; 
    });
  },

  onScrollDown: function() {
    document.getElementById('navbar').classList.remove('scrolled-up');
    document.getElementById('navbar').classList.add('scrolled-down');
  },

  onScrollUp: function() {
    document.getElementById('navbar').classList.remove('scrolled-down');
    document.getElementById('navbar').classList.add('scrolled-up');
  },
  setupScrollListener: function() {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let viewportHeight = window.innerHeight;
    /*const mainContainer = document.getElementById("MainContent");
    const firstImageContentOverlay = mainContainer.firstChild;
    console.log(mainContainer.firstChild.classList.contains('section-image-content-overlay')); // true
    console.log(firstImageContentOverlay);
    if (firstImageContentOverlay.classList.contains('section-image-content-overlay')) {
      console.log("image content overlay first");
      let firstImageContentOverlayHeight = firstImageContentOverlay.offsetHeight;
      console.log("firstImageContentOverlayHeight", firstImageContentOverlayHeight);
    }*/

    if(!(MP.Utilities.isProductPage())){
      window.addEventListener("scroll", function(){
        let st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        
          if (st > 100) {
            document.getElementById('navbar').classList.add('out-of-viewport');
            document.getElementById('navbar').classList.remove('in-viewport');
            /*document.getElementById('navbar').classList.add('bg-white');
            document.getElementById('navbar').classList.remove('bg-transparent');
            document.getElementById('navbar').classList.add('navbar-shadow');*/
          } else {
            document.getElementById('navbar').classList.add('in-viewport');
            document.getElementById('navbar').classList.remove('out-of-viewport');
            /*document.getElementById('navbar').classList.add('bg-transparent');
            document.getElementById('navbar').classList.remove('bg-white');
            document.getElementById('navbar').classList.remove('navbar-shadow');*/
          }
        
        if(Math.abs(st - lastScrollTop) < 200){
          return;
        }
        if (st > lastScrollTop){
          var event = new CustomEvent("interaction:down-scroll");
          document.dispatchEvent(event);
        } else {
          var event = new CustomEvent("interaction:up-scroll");
          document.dispatchEvent(event);
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      }, false);
    } else {
      this.headerSectionElement.classList.remove('fixed-top');
      this.headerSectionElement.classList.add('position-sticky', 'top-0');
    }
  }
}

export default Nav;